const formatDate = (exFactory) => {
  let exFactoryParts = exFactory.trim().split('/')
  let exFactoryDate = new Date(exFactoryParts[2], exFactoryParts[0]-1, exFactoryParts[1])
  exFactory = "" + (exFactoryDate.getMonth()+1) + '/' + exFactoryDate.getDate() + '/' + exFactoryDate.getFullYear()
  return exFactory
}

export {formatDate}
